import { createSlice } from '@reduxjs/toolkit'

import type { PayloadAction } from '@reduxjs/toolkit'

interface MapState {
  isUserAuthorised: boolean
}

const initialState: MapState = {
  isUserAuthorised: true
}

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setUserAuthorised: (state, action: PayloadAction<boolean>) => {
      state.isUserAuthorised = action.payload
    }
  }
})

export const { setUserAuthorised } = mapSlice.actions
export default mapSlice.reducer
